module.exports = __webpack_public_path__ + "static/img/1-1.97404959.png";